export const COST_FETCH_WORKPACKAGES_BEGIN = 'COST_FETCH_WORKPACKAGES_BEGIN';
export const COST_FETCH_WORKPACKAGES_SUCCESS = 'COST_FETCH_WORKPACKAGES_SUCCESS';
export const COST_FETCH_WORKPACKAGES_FAILURE = 'COST_FETCH_WORKPACKAGES_FAILURE';
export const COST_FETCH_WORKPACKAGES_DISMISS_ERROR = 'COST_FETCH_WORKPACKAGES_DISMISS_ERROR';
export const COST_SAVE_COST_BEGIN = 'COST_SAVE_COST_BEGIN';
export const COST_SAVE_COST_SUCCESS = 'COST_SAVE_COST_SUCCESS';
export const COST_SAVE_COST_FAILURE = 'COST_SAVE_COST_FAILURE';
export const COST_SAVE_COST_DISMISS_ERROR = 'COST_SAVE_COST_DISMISS_ERROR';
export const COST_DELETE_COST_BEGIN = 'COST_DELETE_COST_BEGIN';
export const COST_DELETE_COST_SUCCESS = 'COST_DELETE_COST_SUCCESS';
export const COST_DELETE_COST_FAILURE = 'COST_DELETE_COST_FAILURE';
export const COST_DELETE_COST_DISMISS_ERROR = 'COST_DELETE_COST_DISMISS_ERROR';
export const COST_FETCH_COST_CATALOG_BEGIN = 'COST_FETCH_COST_CATALOG_BEGIN';
export const COST_FETCH_COST_CATALOG_SUCCESS = 'COST_FETCH_COST_CATALOG_SUCCESS';
export const COST_FETCH_COST_CATALOG_FAILURE = 'COST_FETCH_COST_CATALOG_FAILURE';
export const COST_FETCH_COST_CATALOG_DISMISS_ERROR = 'COST_FETCH_COST_CATALOG_DISMISS_ERROR';
export const COST_FETCH_UNITS_BEGIN = 'COST_FETCH_UNITS_BEGIN';
export const COST_FETCH_UNITS_SUCCESS = 'COST_FETCH_UNITS_SUCCESS';
export const COST_FETCH_UNITS_FAILURE = 'COST_FETCH_UNITS_FAILURE';
export const COST_FETCH_UNITS_DISMISS_ERROR = 'COST_FETCH_UNITS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/cost/redux/constants.js